import { render, staticRenderFns } from "./previewModal.vue?vue&type=template&id=28fcfdc5"
import script from "./previewModal.vue?vue&type=script&lang=js"
export * from "./previewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports